import { BaseComponent } from './baseComponent';

export class OfferInfoWindow extends BaseComponent {
  static readonly tagName = 'offer-info-window';

  constructor() {
    super();
  }

  protected reader() {
    this.classList.add('focus:outline-none', 'block', 'max-w-[260px]');
    const fragment = document.createDocumentFragment();

    while (this.firstChild) {
      fragment.appendChild(this.firstChild);
    }

    this.innerHTML = `
      <div data-info-window class="info-window bg-white divide-y divide-lightgray grid" @click.stop></div>
    `.trim();

    const infoWindow = this.querySelector('[data-info-window]');

    if (infoWindow && fragment.childNodes.length > 0) {
      infoWindow.appendChild(fragment);
    }
  }
}
